// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"19d2abe9","764":"4a983157"}[chunkId] + ".chunk.js";
};